import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Creators as ProductCreators } from '../../../store/ducks/product';

class LoadingProduct extends Component {

  componentDidMount() {
    const { themes } = this.props.chatbot;
    const filter = {
      themes: themes ? Object.keys(themes).map(key => key) : []
    };

    this.props.getProducts(filter, this.props);
  }

  render() {
    return (
      <div>Por favor, aguarde. Estou buscando as melhores soluções para você...</div>
    )
  }
}

const mapStateToProps = ({ chatbot }) => ({ chatbot });

export default compose(
  connect(mapStateToProps, {
    ...ProductCreators
  })
)(LoadingProduct);